import styled from 'styled-components'

// Configs

export const StyledBBCFormControls = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  span,
  button {
    margin: 0 20px;
  }

  .back-btn {
    opacity: 0.6;
    font-size: 14px;
    text-decoration: underline;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    &:hover {
      opacity: 0.75;
    }
  }
`
